import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { v4 as uuid } from 'uuid';

@Injectable()
export class UserQueryService {
    public CREATE_USER: any;

    public GET_LOGIN_USER: any;
    public GET_CURRENT_USER_DATA: any;
    public GET_ALL_USERS_DATA: any;
    public GET_ALL_PRO_USERS_DATA: any;

    public DELETE_USER: any;
    public UPDATE_USER: any;
    public UPDATE_SPECIFIC_FIELD: any;

    constructor(public apollo: Apollo) {
        /* To create user */
        this.CREATE_USER = gql` 
          mutation CREATE_USER($input: CreateUserInput!) {
            createUser(input: $input) {
                user{
                  roleId
                  userId
                 }
            }
           }
        `;

        /* To check login */
        this.GET_LOGIN_USER = gql`
          query GetUser($email:String,$password:String) {
          allUsers( condition: {email:$email,password:$password} ) {
            edges {
              node {
              firstName
              lastName
              email
              password
              createdAt
              roleId
              userId
              phoneNumber
              company                
              website
              photoUrl
              logoUrl
              roughCarpentry
              finishCarpentry
                plumbing
                electrical
                hvac
                exteriorRoofingSidingGutters
                sheetrockInstall
                sheetrockFinish
                paint
                appliances
                handymanWork
                kitchenRemodeling
                bathroomRemodeling
                roughRadio
                finishRadio
                plumbingRadio
                electricalRadio
                hvacRadio
                exteriorRadio
                sheetrockInstallRadio
                sheetrockFinishRadio
                paintRadio
                appliancesRadio
                handymanWorkRadio
                kitchenRemodelingRadio
                bathroomRemodelingRadio
              roleByRoleId {
                  roleName
                  roleDescription
                }
              }
            }
          }
          }
          `;

        /* Get current user data */
        this.GET_CURRENT_USER_DATA = gql`
        query GetUser($userId:UUID!) {
         allUsers(condition: {userId:$userId} ) {
          edges {
            node {
             firstName
             lastName
             email         
             createdAt
             roleId
             userId
             address
             phoneNumber
             company        
             website
             photoUrl
             logoUrl
             roughCarpentry
             finishCarpentry
             plumbing
             electrical
             hvac
             exteriorRoofingSidingGutters
             sheetrockInstall
             sheetrockFinish
             paint
             appliances
             handymanWork
             kitchenRemodeling
             bathroomRemodeling
             roughRadio
       finishRadio
       plumbingRadio
       electricalRadio
         hvacRadio
       exteriorRadio
       sheetrockInstallRadio
       sheetrockFinishRadio
       paintRadio
       appliancesRadio
       handymanWorkRadio
       kitchenRemodelingRadio
       bathroomRemodelingRadio
             roleByRoleId {
                 roleName
                 roleDescription
               }
            }
          }
        }
        }
         `
            ;
        /* Get all users */
        this.GET_ALL_USERS_DATA = gql`
                query{
                allUsers(orderBy:FIRST_NAME_ASC,condition:{deleteUser:null}) {
                    edges {
                    node {
                        roleId
                        userId
                        firstName
                        lastName
                        email
                        phoneNumber
                        address
                        createdBy
                        company                       
                        website
                        photoUrl
                        logoUrl  
                        roughCarpentry
                        finishCarpentry
                        plumbing
                        electrical
                        hvac
                        exteriorRoofingSidingGutters
                        sheetrockInstall
                        sheetrockFinish
                        paint
                        appliances
                        handymanWork
                        kitchenRemodeling
                        bathroomRemodeling 
                        roughRadio
                        finishRadio
                        plumbingRadio
                        electricalRadio
                        hvacRadio
                        exteriorRadio
                        sheetrockInstallRadio
                        sheetrockFinishRadio
                        paintRadio
                        appliancesRadio
                        handymanWorkRadio
                        kitchenRemodelingRadio
                        bathroomRemodelingRadio
                        scheduledBookingsByAssignedTo {
                        edges {
                            node {
                            buyerProperty
                            firstName
                            lastName
                            buyerAgent
                            orderType
                            insReportId
                            assignedTo
                            }
                        }
                        }
                        roleByRoleId {
                        roleName
                        roleDescription
                        }
                    }
                    }
                }
                }
                `
            ;
        /** Get all pro users */
        this.GET_ALL_PRO_USERS_DATA = gql`
                    query GetProUsers($userType:String!) {
                        allRoles(condition:{roleName:$userType}) {
                        edges {
                            node {
                            roleName
                            usersByRoleId(orderBy:FIRST_NAME_ASC,condition:{deleteUser:null}) {
                                edges {
                                node {
                                    password        
                                    userId
                                    firstName
                                    lastName
                                    email
                                    phoneNumber
                                    address
                                    createdBy
                                    company                       
                                    website
                                    photoUrl
                                    logoUrl  
                                    roughCarpentry
                                    finishCarpentry
                                    plumbing
                                    electrical
                                    hvac
                                    exteriorRoofingSidingGutters
                                    sheetrockInstall
                                    sheetrockFinish
                                    paint
                                    appliances
                                    handymanWork
                                    kitchenRemodeling
                                    bathroomRemodeling 
                                    roughRadio
                                    finishRadio
                                    plumbingRadio
                                    electricalRadio
                                    hvacRadio
                                    exteriorRadio
                                    sheetrockInstallRadio
                                    sheetrockFinishRadio
                                    paintRadio
                                    appliancesRadio
                                    handymanWorkRadio
                                    kitchenRemodelingRadio
                                    bathroomRemodelingRadio
                                }
                                }
                            }
                            }
                        }
                        }
                    }
        `
        //Delete schedule details
        this.DELETE_USER = gql` 
            mutation delteuser($input:DeleteUserByUserIdInput!){
                deleteUserByUserId(input:$input){
                        deletedUserId
                }
            }
        `;
        this.UPDATE_USER = gql`
            mutation updatecontact($input:UpdateUserByUserIdInput!){
                updateUserByUserId(input:$input){
                userEdge{
                    node{
                    firstName
                    }
                }
                }
      }`;
        this.UPDATE_SPECIFIC_FIELD = gql`
        mutation updatecontact($input:UpdateUserByUserIdInput!){
            updateUserByUserId(input:$input){
            userEdge{
                node{
                    phoneNumber
                }
            }
            }
        }`;

    }

    /* To create user */
    REGISTRATION(values, roleId, createdBy): any {
        var userId = createdBy == '' ? uuid() : createdBy;
        return this.apollo.mutate({
            mutation: this.CREATE_USER,
            variables: {
                "input": {
                    "user": {
                        "firstName": values.firstName,
                        "lastName": values.lastName,
                        "email": values.email.toLowerCase(),
                        "password": values.password,
                        "createdAt": new Date(),
                        "address": values.address,
                        "phoneNumber": values.phoneNumber,
                        "userId": createdBy == '' ? userId : uuid(),
                        "roleId": roleId,
                        "createdBy": userId
                    }
                }
            }
        })
    }

    /* To check login */
    LOGIN(values): any {
        return this.apollo.watchQuery({
            query: this.GET_LOGIN_USER,
            variables:
            {
                "email": values.username,
                "password": values.password
            },
            fetchPolicy: 'network-only'
        })
    }

    /* Get current user data */
    GET_CURRENT_USER() {
        return this.apollo
            .query({
                query: this.GET_CURRENT_USER_DATA
                ,
                variables:
                {
                    "userId": window.localStorage.getItem('userUID'),
                },
                fetchPolicy: 'network-only'
            });
    }
    GET_USER_BASED_UID(id): any {
        return this.apollo.watchQuery({
            query: this.GET_CURRENT_USER_DATA,
            variables: {
                "userId": id,
            },
            fetchPolicy: 'network-only'
        })
    }
    /* Get all users email */
    GET_ALL_USERS_EMAIL(): any {
        return this.apollo.query({
            query: this.GET_ALL_USERS_DATA,
            fetchPolicy: 'network-only'
        })
    }

    /* Get all users */
    GET_ALL_USERS() {
        return this.apollo.watchQuery({
            query: this.GET_ALL_USERS_DATA,
            fetchPolicy: 'network-only'
        })
    }
    /**Get pro users */
    GET_ALL_PRO_USERS(userType) {
        return this.apollo.watchQuery({
            query: this.GET_ALL_PRO_USERS_DATA,
            variables: {
                "userType": userType,
            },
            fetchPolicy: 'network-only'
        })
    }

    /*Delete user */
    DELETE_USER_BY_USERID(userId) {
        return this.apollo.mutate({
            mutation: this.DELETE_USER,
            variables: {
                "input": {
                    "userId": userId
                }
            }
        })
    }

    /*Update user */
    UPDATE_USER_BY_USERID(formValue, roleId, userId) {
        return this.apollo.mutate({
            mutation: this.UPDATE_USER,
            variables: {
                "input": {
                    "userPatch":
                    {
                        "firstName": formValue.value.firstName,
                        "lastName": formValue.value.lastName,
                        "email": formValue.value.email,
                        "phoneNumber": formValue.value.phoneNumber,
                        "address": formValue.value.firstName,
                        "roleId": roleId,
                    },
                    "userId": userId
                }
            },
            fetchPolicy: 'no-cache'
        })
    }
    /** Update specific fields */
    UPDATE_SPECIFI_FIELD_BY_USERID(fieldName, fieldValue, userId) {
        return this.apollo.mutate({
            mutation: this.UPDATE_SPECIFIC_FIELD,
            variables: {
                "input": {
                    "userPatch":
                    {
                        [fieldName]: fieldValue
                    },
                    "userId": userId
                }

            },
            fetchPolicy: 'no-cache'
        })
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/users.ts